import { useMutation, useQueryClient } from 'react-query';
import AsnAPI from '../../Api/asn';
import { ASN_QUERY_KEYS } from './asnQueryKeys';

/**
 * Returns a mutation that generates an ASN for the purchase order and, on
 * success, invalidates the cached ASN query for that PO.
 *
 * @param userId - User identifier.
 * @param poNumber - Purchase order number.
 * @returns React Query mutation with no variables (void mutate payload).
 */
export const usePrepareAsnGeneration = (userId: string, poNumber: string) => {
  const queryClient = useQueryClient();

  return useMutation(() => AsnAPI.generateAsn(userId, poNumber), {
    onSuccess: () => {
      queryClient.invalidateQueries(
        ASN_QUERY_KEYS.byPoNumber(userId, poNumber),
      );
    },
  });
};
